var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import MuiAvatar from '@mui/material/Avatar/Avatar';
import React, { useContext } from 'react';
import { Tooltip } from '@mui/material';
import { AvatarContext, groupedClassName, sizeLargeClassName, } from './utils';
var colorArray = [
    '#FF876E',
    '#FFC3BE',
    '#B467C8',
    '#CAA2DD',
    '#52C5B8',
    '#7ADDD4',
    '#A0E9E3',
    '#6F9BF5',
    '#9ABDFB',
    '#AEAEAE',
    '#C8C8C8',
    '#FFDC1E',
    '#FFE881',
    '#CBDFFE',
    '#F38289',
    '#76EFBB',
    '#9FF6D3',
    '#DFCBEE',
    '#5ABC74',
    '#FFC724',
    '#FFE586',
    '#FFAFF7',
    '#CDF2F0',
    '#EBA0A7',
    '#CEFBEA',
    '#FFF4C0',
    '#C0DBB2',
    '#97B0DB',
    '#E8664D',
    '#89A1C4',
    '#95C4C2',
    '#53E0A3',
    '#36B558',
    '#57ABA4',
    '#7DA6E3',
    '#D984D3',
    '#63F2BB',
];
var generatePseudoRandomColor = function (data) {
    // Ensure there's enough data to cover r, g, & b
    data = data.length < 3 ? data.repeat(3) : data;
    // Create hash with , and self modification
    var hash = 0;
    data
        .split('')
        .forEach(function (char) { return (hash = char.charCodeAt(0) + ((hash << 5) - hash)); });
    return colorArray[Math.abs(hash) % colorArray.length];
};
var parseDataForText = function (data) {
    if (data.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
        // Check if email
        if (data.split('@')[0].includes('.')) {
            var splitUsername = data.split('@')[0].split('.');
            return "".concat(splitUsername[0].charAt(0)).concat(splitUsername[1].length > 0 ? splitUsername[1].charAt(0) : '');
        }
    }
    else if (data.includes(' ')) {
        // Check if name
        var splitName = data.split(' ');
        return "".concat(splitName[0].substring(0, 1)).concat(splitName[splitName.length - 1].substring(0, 1));
    }
    // All other cases where text parameter isn't provided by the user
    return data.substring(0, 1).toUpperCase();
};
export var Avatar = function (_a) {
    var className = _a.className, data = _a.data, _b = _a.size, size = _b === void 0 ? 'medium' : _b, _c = _a.text, text = _c === void 0 ? parseDataForText(data) : _c, sx = _a.sx, props = __rest(_a, ["className", "data", "size", "text", "sx"]);
    var isInGroup = useContext(AvatarContext);
    return (React.createElement(Tooltip, { title: data, placement: "top", sx: {
            padding: '6px 8px',
            fontSize: '12px',
            lineHeight: '16px',
            backgroundColor: '#2C2C2C',
            borderRadius: '2px',
        } },
        React.createElement(MuiAvatar, __assign({ className: (size === 'large' && !isInGroup ? "".concat(sizeLargeClassName, " ") : '') +
                (isInGroup ? "".concat(groupedClassName, " ") : '') +
                className, sx: __assign({ backgroundColor: generatePseudoRandomColor(data) }, sx) }, props), (text === '' ? parseDataForText(data) : text)
            .substring(0, 2)
            .toUpperCase())));
};
//# sourceMappingURL=Avatar.js.map